export default class LoadMore {

    constructor() {
        this.settings = {
            $postsList : $('.posts-list')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.$postsList != null) {

            let postsList = this.settings.$postsList;
            let loadNr = $('#js-nr-posts-default').val();
            let loadMoreBtn = $('.js-load-more');

            function postTypeList() {
                $('.post-single').removeClass('hidden');

                postsList.find('.post-single').each(function (index) {

                    // Hide posts
                    if (index >= loadNr) {
                        $(this).addClass('hidden');
                    }
                });
            }

            postTypeList();

            if (postsList.find('.hidden').length === 0) {
                loadMoreBtn.removeClass('btn');
                loadMoreBtn.addClass('hidden');
            }

            loadMoreBtn.on('click', (e) => {

                const $this = e.currentTarget;

                let morePosts = postsList.find('.hidden');
                let counter = 0;
                morePosts.each(function () {

                    // Show more posts
                    if (counter >= loadNr) {
                        return false;
                    }

                    counter++;

                    $(this).removeClass('hidden');
                });

                if (postsList.find('.hidden').length === 0) {
                    $this.classList.remove('btn');
                    $this.classList.add('hidden');
                }
            });

        }

    }
};

new LoadMore();